import React from "react";
import cx from "classnames";
import { models } from "../../data";
import useMediaQuery from "../../hooks/useMediaQuery";
import "./Features.css";

const LineShadow = () => {
  return (
    <>
      <div className="absolute line-shadow-container">
        <div className="line" />
      </div>
      <div className="absolute md:right-0 line-shadow-container line-shadow-2">
        <div className="line" />
      </div>
    </>
  );
};

const Feature: React.FC<{
  name: string;
  icon: string;
  label: string;
  className?: string;
}> = ({ name, icon, label, className }) => {
  const md = useMediaQuery("(min-width: 768px)");
  return (
    <div className={cx("feature", className)}>
      <div className="icon-container">
        <img className="icon" src={icon} alt={name} />
      </div>
      {md ? (
        label.split("\n").map((line, index) => {
          return (
            <div className="text-center" key={`${index}`}>
              {line}
            </div>
          );
        })
      ) : (
        <div className="text-center">{label}</div>
      )}
    </div>
  );
};

const FeaturesSection = ({
  active,
  setActive,
}: {
  active: number;
  setActive: (active: number) => void;
}) => {
  const onHeaderClick = (active: number) => {
    setActive(active);
  };
  return (
    <section id="section-features" className="section-features flex flex-col">
      <div className="header-container z-10 bg-white">
        <ul className="header md:container md:mx-auto flex flex-row overflow-x-scroll overflow-y-hidden md:overflow-hidden">
          {models.map((model, index) => {
            return (
              <li
                key={model.name}
                className={cx(
                  "flex items-center justify-center flex-none md:flex-1 item",
                  index === active && "active"
                )}
                onClick={() => onHeaderClick(index)}
              >
                {model.short}
              </li>
            );
          })}
        </ul>
      </div>
      <div className="content flex flex-col flex-1 w-full z-10 bg-white">
        <div className="container grid flex-1">
          <LineShadow />
          {models[active]?.features.map((feature, i) => (
            <Feature key={feature.name} {...feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
